module.exports = __webpack_public_path__ + "static/media/portfolio1 (61).660ade30.jpeg";